import { t } from "i18next";
import { useRefetchQuery } from "libs/reactQuery";
import toast from "react-hot-toast";
import { Modal } from "ui";

import { useCouponDelete } from "../../../apis";
import { DeleteCouponModalProps } from "./DeleteCouponModal.types";

import styles from "./DeleteCouponModal.module.scss";

const DeleteCouponModal = ({
  isOpen,
  id,
  onClose,
  couponType
}: DeleteCouponModalProps) => {
  const refetchCoupons = useRefetchQuery(["coupons", couponType]);

  const deleteCoupon = useCouponDelete({
    onSuccess: () => {
      onClose();
      refetchCoupons();
      toast.success(t("Coupon has been deleted successfully"));
    }
  });

  return (
    <Modal
      type="delete"
      isOpen={isOpen}
      title={"Delete coupon"}
      isLoading={deleteCoupon.isLoading}
      okText={"Delete"}
      onOk={() => deleteCoupon.mutate(id)}
      contentClassName={styles.deleteQrModal}
      onClose={onClose}
    >
      <p className={styles.deleteQrModal_text}>
        {`${t("Are you sure you want to delete this coupon?")}`}
      </p>
    </Modal>
  );
};

export default DeleteCouponModal;
